import { useState, useEffect } from 'react'

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value)
    const [isTyping, setIsTyping] = useState(false)

    useEffect(() => {
        if (value.trim() && !isTyping) {
            setIsTyping(true)
        }
        const handler = setTimeout(() => {
            setIsTyping(false)
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return { isTyping, debouncedValue }
}
